var _defs, _rect, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _circle4, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullCycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.99,
    y: 52.24,
    width: 9.82,
    height: 18.94
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28,
    y: 35.73,
    width: 9.82,
    height: 35.44
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.92,
    y: 44.95,
    width: 9.82,
    height: 26.23
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.52,
    y: 27.73,
    width: 9.82,
    height: 43.44
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 13.57,
    cy: 39.75,
    r: 5.41
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 29.97,
    cy: 23.14,
    r: 5.41
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 48.51,
    cy: 31.95,
    r: 5.41
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 66.43,
    cy: 14.23,
    r: 5.41
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.66,
    y1: 35.31,
    x2: 25.77,
    y2: 26.54
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.38,
    y1: 23.14,
    x2: 43.84,
    y2: 29.23
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.71,
    y1: 28.55,
    x2: 62.75,
    y2: 18.19
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullCycle);
export default __webpack_public_path__ + "static/media/Full-cycle.5af0dbd4f928ee130942f5f2223cb3ae.svg";
export { ForwardRef as ReactComponent };